import { Middleware } from '@reduxjs/toolkit'

/**
 * Middleware para tratamento global de erros
 */
export const errorHandlerMiddleware: Middleware = () => (next) => (action: unknown) => {
  // Se a action tiver um erro, logar
  const actionType = typeof action === 'object' && action !== null && 'type' in action ? String(action.type) : ''
  if (actionType?.endsWith('/failure') || actionType?.endsWith('/rejected')) {
    let error: unknown = 'Erro desconhecido'
    
    if (typeof action === 'object' && action !== null) {
      if ('payload' in action && typeof action.payload === 'object' && action.payload !== null && 'error' in action.payload) {
        error = (action.payload as { error?: unknown }).error
      } else if ('error' in action && typeof (action as { error?: { message?: string } }).error === 'object' && (action as { error?: { message?: string } }).error !== null) {
        error = (action as { error: { message?: string } }).error.message
      }
    }
    
    console.error('[Redux Error]', actionType, error)
    
    // Aqui você pode adicionar lógica adicional como:
    // - Enviar para serviço de monitoramento (Sentry, etc)
    // - Mostrar toast de erro
    // - etc.
  }

  return next(action)
}

